import { gql } from '@apollo/client';

export const NOTES = gql`
query($data: NoteQuery!) {
  notes(data: $data) {
    count
    results {
      id
      note
      subject
      created_at
      updated_at
      updated_by {
        first_name
        last_name
      }
      created_by {
        first_name
        last_name
      }

      email_recipient
      email_sender
      email_date
      email_direction
      attachments
    }
    cursor {
      previous
      next
    }
  }
}
`

export const CREATE_ACCOUNT_NOTE = gql`
mutation($data: AccountNoteCreateInput!){
    createAccountNote(data: $data){
        id
        note
        subject
        created_at
        updated_at
        updated_by {
          first_name
          last_name
        }
  }
}
`

export const UPDATE_ACCOUNT_NOTE = gql`
mutation($data: AccountNoteUpdateInput!){
    updateAccountNote(data: $data){
        id
        note
        subject
        created_at
        updated_at
        updated_by {
          first_name
          last_name
        }
  }
}
`
export const DELETE_ACCOUNT_NOTE = gql`
mutation($id: ID!){
  deleteAccountNote(id: $id)
}
`
